import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <p className="text-lg font-semibold text-ink-700">페이지를 찾을 수 없습니다</p>
      <p className="text-sm text-slateish-600">
        주소가 바뀌었거나 아직 준비되지 않은 화면일 수 있습니다.
      </p>
      <Link
        to="/"
        className="mt-2 rounded-lg border border-brand-500 px-4 py-2 text-sm font-medium text-brand-500"
      >
        처음 화면으로
      </Link>
    </div>
  )
}
